package com.iregained.site.components.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ClinicalAccreditationLogoStyle = CssStyle {
    base {
        Modifier
            .height(size = 100.px) // Keeps all logos at a uniform height
            .margin(leftRight = 30.px, topBottom = 15.px)
            // Turns logos gray and slightly transparent by default
            .styleModifier { property("filter", "grayscale(0%) opacity(80%)") }
            .transition(
                Transition.of("filter", 0.3.s), 
                Transition.of("transform", 0.3.s)
            )
    }
    hover {
        Modifier
            // Restores full color and opacity on hover
            .styleModifier { property("filter", "grayscale(0%) opacity(100%)") }
            .scale(1.05) // Soft pop effect
    }
}